/*
 * TOPIAM Employee - Employee Identity and Access Management
 * Copyright © 2022-Present Jinan Yuanchuang Network Technology Co., Ltd. (support@topiam.cn)
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
export default {
  'pages.account.user_group_detail.extra.delete': '删除用户组',
  'pages.account.user_group_detail.extra.delete.confirm_title': '您确定要删除此用户组？',
  'pages.account.user_group_detail.extra.delete.confirm_content': '此操作不可恢复，请谨慎操作！',
  'pages.account.user_group_detail.common.username': '用户名称',
  'pages.account.user_group_detail.common.phone': '手机号',
  'pages.account.user_group_detail.common.org_display_path': '所属组织',
  'pages.account.user_group_detail.use_mount.message': '未选择用户组',
  'pages.account.user_group_detail.descriptions.name': '名称',
  'pages.account.user_group_detail.descriptions.code': '编码',
  'pages.account.user_group_detail.descriptions.create_time': '创建时间',
  'pages.account.user_group_detail.descriptions.remark': '备注',
  'pages.account.user_group_detail.tab_list.rule': '规则配置',
  'pages.account.user_group_detail.tab_list.member': '成员信息',
  'pages.account.user_group_detail.tab_list.app_access': '应用权限',
  'pages.account.user_group_detail.tab_list.permission_info': '权限管理',
  'pages.account.user_group_detail.access_strategy': '已授权应用',
  'pages.account.user_group_detail.access_strategy.remove': '取消授权',
  'pages.account.user_group_detail.access_strategy.remove_title': '确定取消该应用授权？',
  'pages.account.user_group_detail.access_strategy.remove_content': '取消后将失去应用访问权限。',
  'pages.account.user_group_detail.app_access_title': '已授权应用',
  'pages.account.user_group_detail.app_access.remove.popconfirm.title': '您确定要取消应用授权？',
  'pages.account.user_group_detail.app_access.remove.popconfirm.remove': '取消授权',
  'pages.account.user_group_detail.add_member.columns.username': '用户名称',
  'pages.account.user_group_detail.add_member.columns.full_name': '用户姓名',
  'pages.account.user_group_detail.add_member.drawer_form.title': '添加成员',
  'pages.account.user_group_detail.add_member.drawer_form.on_finish.message': '请选择要添加的用户',
  'pages.account.user_group_detail.add_member.alert.message': '勾选要添加的用户，点击确认',
  'pages.account.user_group_detail.add_member.pro_table.options.0.search.placeholder':
    '请输入用户名/姓名/手机号',
  'pages.account.user_group_detail.member_list.columns.email': '邮箱',
  'pages.account.user_group_detail.member_list.columns.option': '操作',
  'pages.account.user_group_detail.member_list.columns.option.remove': '移除用户',
  'pages.account.user_group_detail.member_list.columns.option.remove_title':
    '确定将该用户移除用户组吗？',
  'pages.account.user_group_detail.member_list.columns.option.remove_content':
    '移除后，用户将不再拥有该用户组的权限。',
  'pages.account.user_group_detail.member_list.table_alert_option_render.remove': '批量移除',
  'pages.account.user_group_detail.member_list.toolbar.button': '添加成员',
};
